import { GetInvestorQuickLinksRes } from '@dealstack/shared/lib/generated';
import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils.ts';
import {
	buildTableFiltersSearch,
	buildTableQuickFiltersSearch,
} from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperationsFromUrlParamState.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { QuickLink } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/quickLinks.types.ts';

interface Props {
	counts: GetInvestorQuickLinksRes | undefined;
	dealId: string;
	mipId: string;
	investorIds: string[];
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>;
}

export const buildQuickLinks = ({
	counts,
	dealId,
	mipId,
	investorIds,
	tMipManage,
}: Props): QuickLink[] => {
	const labels = {
		investments: tMipManage('investors.details.quick_links.investments'),
		documents: tMipManage('investors.details.quick_links.documents'),
		kyc: tMipManage('investors.details.quick_links.kyc'),
		payments: tMipManage('investors.details.quick_links.payments'),
	};

	const page = (route: MIP_MANAGE_ROUTES) => mipManagePath(route, { dealId, mipId });

	const noQuickFilters = buildTableQuickFiltersSearch({});

	const investmentsPath = page(MIP_MANAGE_ROUTES.INVESTMENTS);
	const investmentsFilter = buildTableFiltersSearch([{ id: 'investorId', value: investorIds }]);

	const kycPath = page(MIP_MANAGE_ROUTES.KYC);
	const kycFilter = buildTableFiltersSearch([{ id: 'investorId', value: investorIds }]);

	const documentsPath = page(MIP_MANAGE_ROUTES.DOCUMENTS);
	const documentsInvestor = { id: 'investorId', value: investorIds };

	// Payments filters client-side, but from the same ?filters= state as the other pages.
	const paymentsPath = page(MIP_MANAGE_ROUTES.PAYMENTS);
	const paymentsInvestor = { id: 'investorId', value: investorIds };

	return [
		{
			key: 'investments',
			label: labels.investments,
			icon: 'money-v3',
			total: counts?.investments ?? 0,
			path: `${investmentsPath}?${investmentsFilter}&${noQuickFilters}`,
		},
		{
			key: 'documents',
			label: labels.documents,
			icon: 'folder',
			total: counts?.documents ?? 0,
			path: `${documentsPath}?${buildTableFiltersSearch([documentsInvestor])}`,
		},
		{
			key: 'kyc',
			label: labels.kyc,
			icon: 'mail',
			total: counts?.kyc ?? 0,
			path: `${kycPath}?${kycFilter}&${noQuickFilters}`,
		},
		{
			key: 'payments',
			label: labels.payments,
			icon: 'plant-grown',
			total: counts?.payments ?? 0,
			path: `${paymentsPath}?${buildTableFiltersSearch([paymentsInvestor])}`,
		},
	];
};
